<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          style="cursor:pointer"
        >view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
            </div>
          </div>
          <h3 class="text-blue mt-5">Inter Agency Training on "Information Gathering & Analysis"</h3>

          <div class="row mt-5">
            <div class="col-lg-7">
              <h4 class="text-blue">Event Brief Information</h4>
            </div>
            <div class="col-lg-5">
              <a
                href="#"
                class="btn btn-primary text-uppercase btn-report float-right ml-3"
              >Print Event Details</a>
              <a href="#" class="btn btn-primary text-uppercase btn-report float-right">Analysis</a>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Country</label> Pakistan
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Province</label> Punjab
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">City</label> Lahore
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Advisor</label> Mr.A
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Program Officer</label> Mr..
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Sub Program / Project</label> PACT
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Donor</label> European Union
            </div>

            <div class="col-sm-8">
              <label class="mr-2 font-weight-bold">Trainers</label> Mr.A, Mr.B, Mr.C
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Start Date</label> 12/12/2020
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">End Date</label> 17/12/2020
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">No. of Days</label> 5
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-lg-7">
              <h4 class="text-blue">Attendees Information</h4>
            </div>
            <div class="col-lg-5">
              <a
                href="#"
                class="btn btn-primary text-uppercase btn-report float-right ml-3"
              >Print Attendance Sheet</a>
              <a href="#" class="btn btn-primary text-uppercase btn-report float-right">Add</a>
            </div>
            <div class="table-responsive pl-3">
              <table class="table table-borderless mt-3">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>CNIC</th>
                    <th>Designation</th>
                    <th>Department</th>
                    <th>Email</th>
                    <th>Number</th>
                    <th>Attendance</th>
                  </tr>
                </thead>
              </table>
              <h5 class="text-blue">Trainees</h5>
              <table class="table table-borderless mt-3">
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Mohsin Abid</td>
                    <td>1235</td>
                    <td>SHO</td>
                    <td>KPK Police</td>
                    <td>john@example.com</td>
                    <td>+1234567</td>
                    <td>Present</td>
                  </tr>

                  <tr>
                    <td>2</td>
                    <td>Mohsin Abid</td>
                    <td>1235</td>
                    <td>SHO</td>
                    <td>KPK Police</td>
                    <td>john@example.com</td>
                    <td>+1234567</td>
                    <td>Present</td>
                  </tr>

                  <tr>
                    <td>3</td>
                    <td>Mohsin Abid</td>
                    <td>1235</td>
                    <td>SHO</td>
                    <td>KPK Police</td>
                    <td>john@example.com</td>
                    <td>+1234567</td>
                    <td>Present</td>
                  </tr>
                </tbody>
              </table>
              <h5 class="text-blue">UNODC Staff & Facilitators</h5>
              <table class="table table-borderless mt-3">
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Amanullah</td>
                    <td>1235</td>
                    <td>M&E</td>
                    <td>KPK Police</td>
                    <td>john@example.com</td>
                    <td>+1234567</td>
                    <td>Present</td>
                  </tr>

                  <tr>
                    <td>2</td>
                    <td>Umair</td>
                    <td>1235</td>
                    <td>M&E</td>
                    <td>KPK Police</td>
                    <td>john@example.com</td>
                    <td>+1234567</td>
                    <td>Present</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

export default {
  data: () => ({
    isActve1: 1,

    isSidebar: false,
    colorx: "warning"
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  created() {},
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    }
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')}
};
</script>

<style scoped>
.text-blue {
  color: #00a4ea;
}
.btn-report {
  background-color: #6488d2 !important;
  border-radius: 0px !important;
  padding: 3px 30px !important;
}
.table th, .table td{
    width:10%
}
</style>
